export const DELETE_MODELS = 'DELETE_MODELS';
